var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.2C24 21.851 21.851 24 19.2 24H4.8C2.14903 24 0 21.851 0 19.2V4.8C0 2.14903 2.14903 0 4.8 0H19.2C21.851 0 24 2.14903 24 4.8V19.2ZM18.6991 4.5L13.2351 10.8515L19.1775 19.5H14.8069L10.8051 13.6761L5.79487 19.5H4.5L10.2302 12.8395L4.5 4.5H8.87056L12.6599 10.0149L17.4043 4.5H18.6991ZM10.881 12.0825L11.4616 12.913L15.4161 18.5696H17.4049L12.5589 11.6379L11.9783 10.8075L8.25028 5.47476H6.26143L10.881 12.0825Z",
    fill: "#001A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterDark);
export default __webpack_public_path__ + "static/media/twitter_dark.cc8bc380b52deedf0de1880b9fd834ea.svg";
export { ForwardRef as ReactComponent };